import { render } from "./DatasetsTable.vue?vue&type=template&id=8d2485b0"
import script from "./DatasetsTable.vue?vue&type=script&lang=js"
export * from "./DatasetsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__